import React from "react";
import serviceone from "../../images/serviceone.png";
import servicetwo from "../../images/servicetwo.png";
import servicethree from "../../images/servicethree.png";
import arrow from "../../icons/Arrow.png";
import btnarrow from "../../icons/btnarrow.png";

const HomeServices = () => {
  return (
    <div className="homeservice mb-5">
      <div className="container">
      <div className="label-head ">-- Our Services --</div>

        <div className="row">
          <div className="col-lg-8">
            <h1>Explore Our Services:</h1>

            <h1>
              <span className="color-primary">Your Path to Success</span>
            </h1>
          </div>
          <div className="col-lg-4">
            <button className="get-started ">
              <img src={btnarrow} alt="" />
              <div className="bg-first color-white">Get Started</div>
            </button>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-4 mt-5">
            <div className="card-service px-4 pt-3 pb-4 ">
              <h3 className="color-white mb-3">Luxury Furniture</h3>
              <p>
                Exquisite craftsmanship meets modern design, offering timeless
                comfort, elegance, and sophistication for refined living.
              </p>
              <div className="card-image">
                <img src={serviceone} alt="" className="rounded-6 w-100" />
                <div className="card-image-icon">
                  <img src={arrow} alt="" />
                </div>
              </div>
            </div>
          </div>{" "}
          <div className="col-lg-4 mt-5">
            <div className="card-service px-4 pt-3 pb-4 ">
              <h3 className="color-white mb-3">Interior Design</h3>
              <p>
                Transforming spaces with creativity, functionality, and elegance
                to reflect your unique style and needs.
              </p>
              <div className="card-image">
                <img src={servicetwo} alt="" className="rounded-6 w-100" />
                <div className="card-image-icon">
                  <img src={arrow} alt="" />
                </div>
              </div>
            </div>
          </div>{" "}
          <div className="col-lg-4 mt-5">
            <div className="card-service px-4 pt-3 pb-4 ">
              <h3 className="color-white mb-3">Hospitality Design</h3>
              <p>
                Creating inviting, elegant spaces that blend comfort,
                functionality, and style to enhance guest experiences.
              </p>
              <div className="card-image">
                <img src={servicethree} alt="" className="rounded-6 w-100" />
                <div className="card-image-icon">
                  <img src={arrow} alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section class="a-section">
        <div class="a-section-marquee-box">
          <h2 class="marquee-text">Residential design *</h2>
          <h2 class="marquee-text">Commercial Design *</h2>
          <h2 class="marquee-text">Hospitality Design *</h2>
          <h2 class="marquee-text">Interior Design *</h2>
          <h2 class="marquee-text">Luxury Furniture </h2>
        </div>
      </section>
    </div>
  );
};

export default HomeServices;
